import React, { PureComponent } from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import { PropTypes } from 'prop-types';
import {
  message, Card, Input, Form, Button,
} from 'antd';
import { injectIntl } from 'react-intl';
import {loginAction, recoverPasswordAction} from '../../../state/actions/creators/auth.actioncreator';
import LoginForm from '../components/LoginForm';
import { handleSagaStatus, obtenerEstadoRequestDesdeSaga } from '../../../helpers/sagaStatus.helper';
import { Flex, Box, Text } from '../../shared/components';
import GIOWEB2Logo from '../../../assets/img/gioweb2_logo.svg';
import { FichaContactologicaFormulario } from '../../pacientes/fichaContactologica/fichaContactologica.form';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGlobe} from "@fortawesome/pro-light-svg-icons";

function RecoverPage({ form, history, intl }) {
  const { getFieldDecorator, setFieldsValue, validateFields } = form;
  const dispatch = useDispatch();
  const  idioma = useSelector((state) => state.app.idioma);
  const inIframe = window.top != window.self;
  if (inIframe) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    validateFields((err, values) => {
      if (!err) {
        dispatch(recoverPasswordAction({...values, locale: idioma}));
      }
    });
  };

  return (
    <Flex style={{ marginTop: '-5%', backgroundColor: '#f0f2f5' }} width="100%" height="100%" justifyContent="center" alignItems="center">
      <Box height="486px">
        <Card bordered={false} className="loginCard" style={{ width: '400px' }}>
          <Box>
            <Flex alignItems="center" flexDirection="column" mt="16" mb="32">
              <img style={{ height: '48px' }} src={GIOWEB2Logo} alt="Logo" />
              <Text color="#918E87" fontSize="18" translationId="app.slogan" mt="16" />
            </Flex>
            <Box p="16px 16px 16px 16px">
              <Text fontWeight="bold" fontSize="12px" translationId="auth.recoverMessage" pb="16px" />
              <Form className="login-form" onSubmit={handleSubmit}>
                <Form.Item>
                  {getFieldDecorator('email', {
                    rules: [{ required: true, message: 'Please input your email!' }],
                  })(<Input
                    size="large"
                    placeholder={intl.formatMessage({ id: 'auth.recoverEmail' })}
                  />)}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator('dominio', {
                    rules: [{ required: true, message: 'Please input your dominio!' }],
                  })(
                    <Input
                      size="large"
                      prefix={<FontAwesomeIcon icon={faGlobe} color="#918E87" />}
                      placeholder="Dominio"
                    />,
                  )}
                </Form.Item>
                <Form.Item>
                  <Button size="large" block type="secondary" onClick={() => history.goBack()} className="login-form-button">
                    {intl.formatMessage({ id: 'auth.cancel' })}
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button size="large" block type="primary" htmlType="submit" className="login-form-button">
                    {intl.formatMessage({ id: 'auth.recover' })}
                  </Button>
                </Form.Item>
              </Form>
            </Box>
          </Box>
        </Card>
      </Box>
    </Flex>
  );
}
export default Form.create()(injectIntl(RecoverPage));
